import React from 'react';
import { Clock, UserPlus, LogIn } from 'lucide-react';
import GoogleIcon from './GoogleIcon';

// Last Login / Signup Method / Last Login Method rows — registered users
// only (guests have no auth_provider / last_login_method fields).
export default function CustomerAuthInfo({ customer }) {
  return (
    <>
      <div className="flex items-center gap-3" data-testid="customer-last-login">
        <Clock className="w-5 h-5 text-muted-foreground" />
        <span className="text-sm">
          {customer.last_login_at
            ? `Last login ${new Date(customer.last_login_at).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`
            : 'Never logged in'}
        </span>
      </div>

      <div className="flex items-start gap-3" data-testid="customer-auth-provider">
        <UserPlus className="w-5 h-5 text-muted-foreground mt-0.5 shrink-0" />
        <div>
          <p className="text-xs text-muted-foreground uppercase font-bold mb-0.5 tracking-wide">Signup Method</p>
          {customer.auth_provider === 'google' ? (
            <span className="flex items-center gap-1.5 text-sm">
              <GoogleIcon />
              Google
            </span>
          ) : (
            <span className="text-sm">Email &amp; Password</span>
          )}
        </div>
      </div>

      <div className="flex items-start gap-3" data-testid="customer-last-login-method">
        <LogIn className="w-5 h-5 text-muted-foreground mt-0.5 shrink-0" />
        <div>
          <p className="text-xs text-muted-foreground uppercase font-bold mb-0.5 tracking-wide">Last Login Method</p>
          {customer.last_login_method === 'google' ? (
            <span className="flex items-center gap-1.5 text-sm">
              <GoogleIcon />
              Google
            </span>
          ) : customer.last_login_method === 'password' ? (
            <span className="text-sm">Email &amp; Password</span>
          ) : (
            <span className="text-sm text-muted-foreground">No record yet</span>
          )}
        </div>
      </div>
    </>
  );
}
